/**
 * .nyb-hover-autoplay
 *
 * Add this class to any wrapper element to make the first native <video>
 * inside it play on hover and pause (+ reset) when the cursor leaves.
 * External videos (iframes / video-media[host]) are intentionally ignored.
 *
 * Usage:
 *   <div class="nyb-hover-autoplay">
 *     <!-- any video-media or plain video inside -->
 *   </div>
 */

function getNativeVideoMedia(wrapper) {
  // Prefer a video-media custom element without a host (= native video).
  // Falls back to a plain <video> for non-theme usage.
  return (
    wrapper.querySelector('video-media:not([host])') ||
    wrapper.querySelector('video')
  );
}

function playMedia(target) {
  if (target.tagName === 'VIDEO-MEDIA') {
    const video = target.querySelector('video');
    if (!video) return;

    // Ensure the browser allows programmatic play
    video.muted = true;

    // Kick preload if the browser hasn't fetched anything yet
    if (video.preload === 'none' || video.preload === '') {
      video.preload = 'metadata';
    }

    // Use the custom element's own play() so its internal state is correct
    target.play();
  } else {
    // Plain <video> fallback
    target.muted = true;
    target.play().catch(() => {});
  }
}

function pauseMedia(target) {
  if (target.tagName === 'VIDEO-MEDIA') {
    const video = target.querySelector('video');
    target.pause();
    if (video) video.currentTime = 0;
  } else {
    target.pause();
    target.currentTime = 0;
  }
}

document.addEventListener('mouseover', (event) => {
  const wrapper = event.target.closest('.nyb-hover-autoplay');
  if (!wrapper) return;
  if (wrapper.contains(event.relatedTarget)) return;

  const media = getNativeVideoMedia(wrapper);
  if (!media) return;

  playMedia(media);
});

document.addEventListener('mouseout', (event) => {
  const wrapper = event.target.closest('.nyb-hover-autoplay');
  if (!wrapper) return;
  if (wrapper.contains(event.relatedTarget)) return;

  const media = getNativeVideoMedia(wrapper);
  if (!media) return;

  pauseMedia(media);
});
